import type { LaunchNetworkConfig } from "@models/launchNetwork.model";
import { CommandToggleLaunchNetwork } from "./commands/cmdToggleNetwork";
import { CommandSelectLaunchTemplate } from "./commands/cmdSelectNetworkTemplate";
import { CommandGetLaunchNetworks } from "./commands/cmdGetLaunchNetworks";
import { CommandSelectNetworkResource } from "./commands/cmdSelectNetworkAccount";
import { CommandGetLaunchNetworkLinks } from "./commands/cmdGetLaunchNetworkLinks";
import { CommandPatchLaunchNetworkLink, type PatchNetworkLinkPayload } from "./commands/cmdPatchLaunchNetworkLink";
import type { LaunchNetworkLinks, NetworkLinkObjectType, NetworkLinkState } from "@models/launchNetworkLinks.model";

export class LaunchNetworkService {
  async toggle(launchId: number, network: string, isEnabled: boolean): Promise<LaunchNetworkConfig> {
    return await new CommandToggleLaunchNetwork().run(launchId, network, isEnabled);
  }

  async selectTemplate(launchId: number, network: string, networkTemplateId: number): Promise<LaunchNetworkConfig> {
    return await new CommandSelectLaunchTemplate().run(launchId, network, networkTemplateId);
  }

  async getConfigs(launchId: number) {
    return await new CommandGetLaunchNetworks().run(launchId);
  }

  async updateAccount(launchId: number, network: string, networkResourceId: number, subResourceId?: number): Promise<LaunchNetworkConfig> {
    return await new CommandSelectNetworkResource().run(launchId, network, networkResourceId, subResourceId);
  }

  async getLinks(launchId: number, network: string): Promise<LaunchNetworkLinks> {
    return await new CommandGetLaunchNetworkLinks().run(launchId, network);
  }

  async patchLink(
    launchId: number,
    network: string,
    kind: NetworkLinkObjectType,
    objectId: number,
    payload: PatchNetworkLinkPayload,
  ): Promise<NetworkLinkState> {
    return await new CommandPatchLaunchNetworkLink().run(launchId, network, kind, objectId, payload);
  }
}
